export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7591.e6b6eb50.jpg";